import React from 'react';
interface GradientWrapperProps {
  radius: string;
  paddingPx?: number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}
const GradientWrapper: React.FC<GradientWrapperProps> = ({
  radius,
  paddingPx = 1,
  className = '',
  style = {},
  children
}) => {
  const gradientStyle: CSSProperties = {
    background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
    padding: `${paddingPx}px`,
    borderRadius: radius,
    ...style
  };
  const innerStyle: CSSProperties = {
    backgroundColor: '#FFFFFF',
    borderRadius: `calc(${radius} - ${paddingPx}px)`,
    width: '100%',
    height: '100%'
  };
  return <div style={gradientStyle} className={className} data-id="element-1253">
      <div style={innerStyle} data-id="element-1254">{children}</div>
    </div>;
};
export default GradientWrapper;